import cx from 'classnames'
import NextImage from 'next/image'
import { useContext } from 'react'

import { getBasicImageLoader } from '../lib/image'
import { FrameBuilderStringsContext } from '../contexts/strings-context'

import NewLineToBr from './utility/new-line-to-br'

interface InfoBalloonProps {
  withGraphic: boolean
  className?: string
}

const InfoBalloon = ({ withGraphic, className }: InfoBalloonProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  const text = withGraphic
    ? frameBuilderStrings.controlAddToCartHint
    : frameBuilderStrings.controlChooseProductHint

  if (!text) {
    return null
  }

  return (
    <div
      className={cx(
        'flex justify-center items-center py-5 px-5 md:px-10 bg-white',
        className,
      )}
    >
      {withGraphic && (
        <NextImage
          src="/frame-builder/star.png"
          width="105"
          height="105"
          alt="Star"
          loader={getBasicImageLoader}
          unoptimized
          className="block w-[84px] h-[84px] sm:w-[66px] sm:h-[66px] md:w-[84px] md:h-[84px]"
        />
      )}

      <div
        className={cx('ml-5 text-sm leading-5', {
          'text-center': !withGraphic,
          'text-left': withGraphic,
        })}
      >
        <NewLineToBr>{text}</NewLineToBr>
      </div>
    </div>
  )
}

export default InfoBalloon
